import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MdChevronRight } from 'react-icons/md';
import CampaignDrawer from './CampaignDrawer';

const Analytics: React.FC = () => {
  const [dateFrom, setDateFrom] = useState('Jan 1, 2022');
  const [dateTo, setDateTo] = useState('Dec 31, 2022');
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  // Platform stats data with random numbers
  const platformStats = [
    {
      name: 'Facebook',
      color: '#1877F2',
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
      ),
      stats: {
        views: '24',
        reach: '37',
        clicks: '89',
        engagement: '46'
      }
    },
    {
      name: 'Instagram',
      color: '#E1306C',
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
        </svg>
      ),
      stats: {
        views: '21',
        reach: '4',
        clicks: '56',
        engagement: '678'
      }
    },
    {
      name: 'TikTok',
      color: '#FFFFFF',
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
        </svg>
      ),
      stats: {
        views: '56',
        reach: '92',
        clicks: '34',
        engagement: '91'
      }
    },
    {
      name: 'Email',
      color: '#EE4423',
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 20 20">
          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
        </svg>
      ),
      stats: {
        views: '98',
        reach: '25',
        clicks: '53',
        engagement: '32'
      }
    }
  ];

  return (
    <div className="p-3">
      {/* Header Section */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h1 className="text-2xl font-bold text-[#EE4423] mb-2">The War and Treaty</h1>
        </div>

        {/* Other Campaigns Button */}
        <button 
          onClick={() => setIsDrawerOpen(true)}
          className="flex items-center gap- text-gray-300 text-sm cursor-pointer font-normal hover:text-[#EE4423] transition-colors"
        >
          More Campaigns
          <MdChevronRight size={24} />
        </button>
      </div>

      {/* Campaign Drawer */}
      <CampaignDrawer isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} />

      {/* Main Content Grid */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
        {/* Left Side - Platform Stats Grid */}
        <div className="xl:col-span-2">
          <div className="grid grid-cols-1 md:grid-cols-1 gap-6">

            {/* <div className="flex items-center  gap-2">
              <span className="text-white text-[10px]">Select period:</span>
              <button className="px-3 py-1.5 rounded-lg border border-gray-600 bg-gray-800/50 text-white text-[10px]">
                from {dateFrom}
              </button>
              <button className="px-3 py-1.5 rounded-lg border border-gray-600 bg-gray-800/50 text-white text-[10px]">
                to {dateTo}
              </button>
            </div> */}

            {platformStats.map((platform) => (
              <motion.div
                key={platform.name}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="rounded-2xl p-6 relative overflow-hidden flex items-center gap-6"
                style={{
                  backdropFilter: 'blur(10px)',
                  boxShadow: '0 0 14px 0 #0000001a',
                  background: 'linear-gradient(90deg, #212121eb, #373737eb)',
                  border: '1px solid #e0e0e021'
                }}
              >
                {/* Stats Row - Horizontal Layout */}
                <div className="grid grid-cols-4 gap-6 flex-1">
                  <div className='text-center'>
                    <div className="text-white text-4xl font-light mb-2">{platform.stats.views}</div>
                    <div className="text-[#EE4423] text-sm font-light">Views</div>
                  </div>
                  <div className='text-center'>
                    <div className="text-white text-4xl font-light mb-2">{platform.stats.engagement}</div>
                    <div className="text-[#EE4423] text-sm font-light">Engagement</div>
                  </div>
                  <div className='text-center'>
                    <div className="text-white text-4xl font-light mb-2">{platform.stats.clicks}</div>
                    <div className="text-[#EE4423] text-sm font-light">Clicks</div>
                  </div>
                  <div className='text-center'>
                    <div className="text-white text-4xl font-light mb-2">{platform.stats.reach}</div>
                    <div className="text-[#EE4423] text-sm font-light">Reach</div>
                  </div>
                </div>

                {/* Vertical Divider */}
                <div className="h-24 w-px bg-gray-600/50"></div>

                {/* Platform Icon and Name */}
                <div className="flex flex-col items-center justify-center gap-2 min-w-[100px]">
                  <div
                    style={{ color: platform.color }}
                  >
                    {platform.icon}
                  </div>
                  <span className="text-white text-sm font-normal lowercase">{platform.name}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Right Side - Campaign Info & Image */}
        <div className="space-y-3 sticky top-6 self-start">
          {/* Date Range Selector */}


          {/* Campaign Info Card */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            className="rounded-2xl p-6 bg-gradient-to-br from-[#EE4423]/90 to-[#EE4423]/70 border border-amber-700/50"
          >
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <span className="text-white font-medium">Created on</span>
                <span className="text-white/80">01/04/2026</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-white font-medium">Campaign Duration</span>
                <div className="text-right">
                  <div className="text-white/80">01/04/2026 -</div>
                  <div className="text-white/80">12/04/2026</div>
                  <div className="text-white/80">7 Days</div>
                </div>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-white font-medium">Remaining Days</span>
                <span className="text-white/80">3 Days</span>
              </div>

            </div>
          </motion.div>

          {/* Campaign Image Card */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.1 }}
            className=" max-w-sm text-center margin-auto"
            style={{ border: '1px solid #e0e0e021', margin: "0 auto" }}>
            <img
              src="https://snapmenu-restaurant-workers.raghavan-7fc.workers.dev/files/1770250692791-generated_flyer.jpeg"
              alt="Campaign Flyer"
              className="w-full h-auto object-cover"
            />

          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
